import dayjs from 'dayjs';

export default function getTimeAgo(value: string) {
  const now = dayjs();
  const date = dayjs(value);

  if (Math.abs(date.diff(now, 'week', true)) > 1) {
    return date.format('YYYY-MM-DD');
  }

  if (Math.abs(date.diff(now, 'second', true)) < 60) {
    return `${Math.abs(date.diff(now, 'second'))}초 전`;
  }

  if (Math.abs(date.diff(now, 'minute', true)) < 60) {
    return `${Math.abs(date.diff(now, 'minute'))}분 전`;
  }

  if (Math.abs(date.diff(now, 'hour', true)) < 24) {
    return `${Math.abs(date.diff(now, 'hour'))}시간 전`;
  }

  return `${Math.abs(date.diff(now, 'day'))}일 전`;
}
